import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'card-text-search',
  templateUrl: './card-text-search.component.html',
  styleUrls: ['./card-text-search.component.scss'],
})
export class CardTextSearchComponent implements OnInit {
  @Input() tarea;
  @Input() caso;

  constructor(
    private caseService: CasesService,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {}
  async goToCase(id) {
    await this.caseService.getCase(id).subscribe((iCase) => {
      if (
        iCase.status != 'archived' ||
        this.userService.currentUser.role.seeArchivedCases
      ) {
        this.router.navigate([`../../case/${id}`]);
      }
    });
  }
}
